<template>
  <div class="flex items-center justify-center gap-2">
    <!-- Previous page -->
    <button class="p-1.5 rounded-md border border-border-normal transition-colors"
    :class="canGoPrev ? 'text-icon-normal hover:bg-neutral-25' : 'text-icon-disabled cursor-default'"
    :disabled="!canGoPrev" @click="changePage(currentPage - 1)">
      <ChevronRightIcon class="transform rotate-180" />
    </button>
    <!-- Page numbers -->
    <div class="flex items-center gap-2">
      <template v-for="(page, index) in displayedPages">
        <div v-if="page === null" :key="`ellipsis-${index}`" class="flex items-center justify-center w-8 h-8">
          <BaseText type="body" size="sm" class="text-text-normal">
            &hellip;
          </BaseText>
        </div>
        <button v-else :key="`page-${page}`" class="flex items-center justify-center w-8 h-8 rounded-lg transition-colors"
        :class="page === currentPage ? 'bg-neutral-25 cursor-default' : 'hover:bg-neutral-25'"
        :disabled="disabled" @click="changePage(page)">
          <BaseText :type="page === currentPage ? 'label' : 'body'" size="sm"
          :class="page === currentPage ? 'text-text-muted' : 'text-text-normal'">
            {{ page }}
          </BaseText>
        </button>
      </template>
    </div>
    <!-- Next page -->
    <button class="p-1.5 rounded-md border border-border-normal transition-colors"
    :class="canGoNext ? 'text-icon-normal hover:bg-neutral-25' : 'text-icon-disabled cursor-default'"
    :disabled="!canGoNext" @click="changePage(currentPage + 1)">
      <ChevronRightIcon />
    </button>
  </div>
</template>

<script>
import ChevronRightIcon from './Icons/ChevronRightIcon.vue'

// The most page slots (page numbers + ellipses) shown at once
const MAX_SLOTS = 7

export default {
  name: 'BasePagination',
  components: {
    ChevronRightIcon
  },
  props: {
    // 1-based
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canGoPrev () {
      return !this.disabled && this.currentPage > 1
    },
    canGoNext () {
      return !this.disabled && this.currentPage < this.totalPages
    },
    // Page numbers to render, with `null` standing in for an ellipsis.
    // e.g. 1 2 3 … 6 7 8 near either end, 1 … 4 5 6 … 12 in the middle
    displayedPages () {
      const current = this.currentPage
      const total = this.totalPages
      if (total <= MAX_SLOTS) return Array.from({ length: total }, (_, i) => i + 1)
      if (current <= 3 || current >= total - 2) return [1, 2, 3, null, total - 2, total - 1, total]
      return [1, null, current - 1, current, current + 1, null, total]
    }
  },
  methods: {
    changePage (page) {
      if (this.disabled || page === this.currentPage || page < 1 || page > this.totalPages) return
      this.$emit('change', page)
    }
  }
}
</script>
